// extracted by mini-css-extract-plugin
module.exports = {"Link":"ProfileLink_Link__2nvXJ","linkedin":"ProfileLink_linkedin__2ey6d","twitter":"ProfileLink_twitter__1uLj_","IconWrapper":"ProfileLink_IconWrapper__CMVbR"};